import { render } from "./NewApheresisScreeningForm.vue?vue&type=template&id=57915cf7&scoped=true"
import script from "./NewApheresisScreeningForm.vue?vue&type=script&lang=js"
export * from "./NewApheresisScreeningForm.vue?vue&type=script&lang=js"

import "./NewApheresisScreeningForm.vue?vue&type=style&index=0&id=57915cf7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57915cf7"]])

export default __exports__